import { Component } from '@angular/core';

@Component({
  selector: 'app-business-conditions',
  templateUrl: './business-conditions.component.html',
  styleUrls: ['./business-conditions.component.scss']
})
export class BusinessConditionsComponent {

}
